'use strict';

module.exports = /*@ngInject*/ ["rx", "ZabbixIssueFactory", "ZabbixOverviewFactory", "ZabbixResourceService", "MonitoringResource", "TrainDataService", "TrainConsistResourceService", "IncidentService","TrainService", function MonitoringTrainDetailsService(
                            rx, 
                            ZabbixIssueFactory,
                            ZabbixOverviewFactory,
                            ZabbixResourceService,
                            MonitoringResource,
                            TrainDataService,
                            TrainConsistResourceService,
                            IncidentService,
                            TrainService
                            ) {

  var serviceAPI = {
    getTrainDetails: getTrainDetails
  };
  
 
  function getTrainDetails(projectId, trainId) {
      // /rest/monitoring/context/$TRAIN_ID?projectId=$PROJECT_ID$
    var rawTrain$ = getTrainInformation(projectId, trainId).catch(function() { 
      return rx.Observable.of([]);
    });

      // /rest/monitoring/links/$TRAIN_ID?projectId=$PROJECT_ID$
    var trainLinks$ = getTrainLinks(projectId, trainId).catch(function() { 
      return rx.Observable.of([]);
    });

    // rest/traindata/$TRAIN_ID?projectId=$PROJECT_ID$
    var trainData$ = getTrainData(projectId, trainId).catch(function() { 
      return rx.Observable.of([]);
    });

    // /rest/zabbix/structure/$TRAIN_ID?projectId=$PROJECT_ID              
    var zabbixIssues$ = getTrainZabbixIssues(projectId, trainId).catch(function() { 
      return rx.Observable.of([]);
    });

    // /rest/monitoring/alarms/$TRAIN_ID?projectId=$PROJECT_ID
    var trainIssues$ = getTrainIssues(projectId, trainId).catch(function() {
      return rx.Observable.of([]);
    });

    // /rest/zabbix/structure/$TRAIN_ID?projectId=1
    var trainStructure$ = getTrainStructure(projectId, trainId).catch(function() { 
      return rx.Observable.of([]);
    });

    // /restonfig/consist/latest/config/consist/latest?projectId=1&trainId=$TRAIN_ID
    var trainLatestConsist$ = getTrainLatestConsist(projectId, trainId).catch(function() { 
      return rx.Observable.of([]);
    });

    // /rest/project/:projectId/trains/:trainId/configuration
    var trainTypeConfiguration$ = getTrainTypeConfiguration(projectId, trainId).catch(function() { 
      return rx.Observable.of([]);
    });

    // /rest/zabbix/custom/config/$TRAIN_ID?projectId=1
    var trainCustomConfig$ = getTrainCustomConfig(projectId, trainId).catch(function() { 
      return rx.Observable.of([]);
    });

    // /rest/monitoring/alarmEvents/$TRAIN_ID?projectId=$PROJECT_ID  
    var trainAlarmEvents$ = getTrainAlarmEvents(projectId, trainId).catch(function() {
      return rx.Observable.of([]);
    });

    var trainIncidents$ = getTrainIncidents(projectId, trainId).catch(function() { 
      return rx.Observable.of([]);
    });


    return rx.Observable.zip(rawTrain$, trainLinks$, trainData$, zabbixIssues$, trainAlarmEvents$ , trainLatestConsist$, trainTypeConfiguration$, trainCustomConfig$, trainIncidents$, trainStructure$ , trainIssues$)
    .map((result) => { 
        var train =  {
            name: result[0].name,
            trainId: result[0].trainId,
            officialId: result[0].officialId,
            projectId: result[0].projectId,
            inService: result[0].inService,
            diagnostics: result[0].diagnostics,
            lastSeen: result[0].diagnostics ? result[0].diagnostics.lastSeen : 0,
            issues: result[0].issues,
            severity: result[0].level, 
            location: (result[0].diagnostics && result[0].diagnostics.location) ? result[0].diagnostics.location.fullLocation : '',
            speed: result[0].diagnostics ? result[0].diagnostics.speed : '',
            upToDate: result[0].diagnostics ? result[0].diagnostics.upToDate : false,
            users: result[0].diagnostics ? result[0].diagnostics.users : [],
            maintainer: result[0].diagnostics ? result[0].diagnostics.maintainer : null,
            inDepot: result[0].diagnostics ? result[0].diagnostics.inDepot : false,
            timestamp: result[0].timestamp,
            links: result[1]? result[1].map(function(link) {
              return link; 
            }) : [],
            position: {
              latitude: result[2].currentLatitude,
              longitude: result[2].currentLongitude,
            },
            heading: result[2].heading,
            speed: result[2].speed,
            upToDate: result[2].upToDate,
            messageInfo: result[2].messageInfo,
            alarmEvents: result[4],
            trainConsists: result[5],
            trainTypeConfiguration: result[6],
            trainConsistView: result[6] && result[6].trainConsistView,
            customZabbixConfig: result[7],
            incidents: result[8],
            structure: result[9]
       }

       train.dynamicConsist = train.trainTypeConfiguration && train.trainTypeConfiguration.dynamicConsist;
       
       train.issues = result[10].map((currentIssue) => {
            currentIssue.trainId = train.trainId;
            currentIssue.trainOfficialId = train.officialId;
            currentIssue.trainName = train.name;
              return currentIssue;
        })

       var simAlarmObj = {
          level: 0,
          count: 0
        };

        if(train.issues) {
          train.issues.forEach(function (simAlarm) {
              if (simAlarm.type === 'sim-usage-alarm'){
            if (simAlarm.level > simAlarmObj.level) {
              simAlarmObj.level = simAlarm.level;
            }
            simAlarmObj.count++;
          }});
          train.simAlarm = simAlarmObj;
        }
        var totalDown = train.links.reduce(function(total, linkInfo) {
          return total + linkInfo.downloadRate;
        }, 0);  
        var totalUp = train.links.reduce(function(total, linkInfo) {
          return total + linkInfo.uploadRate;
        }, 0);  
        train.totalDownloadRate = totalDown;
        train.totalUploadRate = totalUp;
        train.totalDownloadRateKbit = totalDown * 1000;
        train.totalUploadRateKbit = totalUp * 1000;
        return train;
    }).catch(function(e) {
      return rx.Observable.throw(e);
    });
  }

  function getTrainInformation(projectId, trainId) {
    return rx.Observable.fromPromise(MonitoringResource.getInformation().get({
      'projectId': projectId,
      'trainId': trainId
    }).$promise).map(function (result) {
      return JSON.parse(JSON.stringify(result));
  })
  }

  function getTrainLinks(projectId, trainId) {
    return rx.Observable.fromPromise(MonitoringResource.getLinkInformation().query({
      'projectId': projectId,
      'trainId': trainId
  }).$promise).map(function (result) {
    return JSON.parse(JSON.stringify(result));
})
  }

  function getTrainData(projectId, trainId) {
    return rx.Observable.fromPromise(TrainDataService.get({
      'projectId': projectId,
      'id': trainId
  }).$promise).map(function (result) {
    return JSON.parse(JSON.stringify(result));
})
  }



  function getTrainZabbixIssues(projectId, trainId) {
    return rx.Observable.fromPromise(ZabbixResourceService.structure().get({
      projectId: projectId,
      trainId: trainId
  }).$promise)
      .map(function (trainIssues) {
        var issues = [JSON.parse(JSON.stringify(trainIssues))];
        return preprocessIssues(issues);
      });
  }

  function getTrainStructure(projectId, trainId) {
    return rx.Observable.fromPromise(ZabbixIssueFactory.getZabbixIssues(projectId, trainId)).map(function(trainStructure) {
      var proxyUpDate = ZabbixOverviewFactory.adjustOfflineProxyPriorities([trainStructure]);
      var structureData = ZabbixOverviewFactory.makeStructure(proxyUpDate);
      var orderedData = ZabbixOverviewFactory.orderData(structureData);
      var hashStructure = ZabbixOverviewFactory.fillHashCodes(orderedData);
      var priorityStructure = ZabbixOverviewFactory.fillPriorities(hashStructure);
      var newStructure = ZabbixOverviewFactory.calculateCoachSeverity(priorityStructure);
      return JSON.parse(JSON.stringify(newStructure[0]));
      });
  }

  function getTrainLatestConsist(projectId, trainId) {
    return rx.Observable.fromPromise(TrainConsistResourceService.getLatestConsist().query({
      projectId: projectId,
      trainId: trainId
  }).$promise).map(function (result) {
      return JSON.parse(JSON.stringify(result));
  });

  }

    function getTrainTypeConfiguration(projectId, trainId) {
      return rx.Observable.fromPromise(TrainService.getTypeConfiguration(projectId).get({
        projectId: projectId,
        trainId: trainId
      }).$promise).map(function(result) {
        return JSON.parse(JSON.stringify(result));
      }); 
    }

    function getTrainCustomConfig(projectId, trainId) {
      return rx.Observable.fromPromise(ZabbixResourceService.customConfig().get(
        {
            projectId: projectId,
            trainId: trainId
        }).$promise).map(function(result) {
          return JSON.parse(JSON.stringify(result));
        });
    }

    function getTrainAlarmEvents(projectId, trainId) {
      return rx.Observable.fromPromise(MonitoringResource.getAlarmEvents().query({
        projectId: projectId,
        trainId: trainId
    }).$promise).map(function (result) {
        return JSON.parse(JSON.stringify(result));
    });
    }

    function getTrainIssues(projectId, trainId) {
      return rx.Observable.fromPromise(MonitoringResource.getTrainAlarms().query({
        projectId: projectId,
        trainId: trainId
    }).$promise).map(function (result) {
        return JSON.parse(JSON.stringify(result));
    });
    }

    function getTrainIncidents(projectId, trainId) {
      return rx.Observable.fromPromise(IncidentService.getTrainIncidents().query({ 
        'projectId': projectId, 
        'trainId': trainId }).$promise).map(function (result) {
              return JSON.parse(JSON.stringify(result));
            });
    }

  var preprocessIssues = function(data) {
    var trainStructures = [];
    var proxyUpDate = ZabbixOverviewFactory.adjustOfflineProxyPriorities(data);
    var structureData = ZabbixOverviewFactory.makeStructure(proxyUpDate);
    var orderedData = ZabbixOverviewFactory.orderData(structureData);
    var structure = ZabbixOverviewFactory.fillHashCodes(orderedData);
    trainStructures = ZabbixOverviewFactory.fillPriorities(structure);
  
    var allIssues = [];
    trainStructures.forEach(function (train) {
        var issues = ZabbixIssueFactory.findIssues(train, 'train');
        var issuesWithSorting = ZabbixIssueFactory.fillAcknowledgeSort(issues);
  
        allIssues = allIssues.concat(issuesWithSorting);
    });
    return ZabbixIssueFactory.convertZabbixIssueToIssue(allIssues);
  };

  return serviceAPI;

}];
